import { useMutation, useQueryClient } from '@tanstack/react-query'

import { showErrorToast } from 'common/api/helpers'
import { successToast } from 'common/components/toastNotification'
import { useAppSelector } from 'common/hooks/redux'

import { deleteCustomerAttributeRecord } from '../api'
import { keys as dataSourcesKeys } from '../queryKeys'

type DeleteCustomerAttributeRecordVariables = {
  catalogueAttributeId: string
  region: string
}

const useDeleteCustomerAttributeRecordMutation = () => {
  const accountId = useAppSelector((state) => state.authStates.accountId)
  const queryClient = useQueryClient()

  return useMutation<void, Error, DeleteCustomerAttributeRecordVariables>(
    ({ catalogueAttributeId, region }) =>
      deleteCustomerAttributeRecord({
        accountId,
        catalogueAttributeId,
        region,
      }),
    {
      onSuccess: () => {
        successToast('Customer attribute record deleted successfully.')
        queryClient.invalidateQueries(
          dataSourcesKeys.customerAttributeRecords({
            accountId,
          })
        )
      },
      onError: (error) => {
        showErrorToast(error)
      },
    }
  )
}

export default useDeleteCustomerAttributeRecordMutation
